/**
 * Biomarker names that are used for analysis and charting.
 * This file should have no internal dependencies to avoid circular imports.
 */

/**
 * The different kinds of biomarkers supported by the system.
 */
export enum BiomarkerNames {
    CONNECTIVITY_WPLI = "connectivity_wpli",
    CONNECTIVITY_TPLI = "connectivity_tpli",
    HR = "hr",
    HRV = "hrv",
    BAND_POWER = "band_power",
    POWER_RATIO = "power_ratio",
}


export enum BiomarkerColumnNames {
    SUBJECT_ID = "subject_id",
    PROTOCOL_ID = "protocol_id",
    BIOMARKER = "biomarker",
    FREQUENCY_BAND = "frequency_band",
    CHANNEL_NAME = "channel_name",
    STIM_STEP_ID = "stim_step_id",
    PRE_STIM_MEAN_VALUE = "pre_stim_mean_value",
    STIM_MEAN_VALUE = "stim_mean_value",
    POST_STIM_MEAN_VALUE = "post_stim_mean_value",
    PRE_TO_POST_DELTA = "pre_to_post_delta",
    PRE_STIM_VALUES = "pre_stim_values",
    STIM_VALUES = "stim_values",
    POST_STIM_VALUES = "post_stim_values",
    PRE_STIM_TIMES = "pre_stim_times",
    STIM_TIMES = "stim_times",
    POST_STIM_TIMES = "post_stim_times",
    PRE_TO_POST_P_VALUE = "pre_to_post_p_value",
    PRE_TO_STIM_P_VALUE = "pre_to_stim_p_value",
    STIM_TO_POST_P_VALUE = "stim_to_post_p_value",
}
